import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "bus" | "people";

interface IState {
  visible: boolean;
  surveyShowType: number;
  markerMode: SelectingType[];
  heatmapMode: SelectingType;
  pointwiseShow: boolean;
  loading: boolean;
  type: Type;
}

const initialState: IState = {
  visible: false,
  surveyShowType: 0,
  markerMode: ["source"],
  heatmapMode: "source",
  pointwiseShow: false,
  loading: false,
  type: "people",
};

export const surveysSlice = createSlice({
  name: "surveys",
  initialState,
  reducers: {
    changeSurveyShowType: (state, action: PayloadAction<number>) => {
      return { ...state, surveyShowType: action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    changeMarkerMode: (state, action: PayloadAction<SelectingType[]>) => {
      return { ...state, markerMode: action.payload };
    },
    changeHeatMapMode: (state, action: PayloadAction<SelectingType>) => {
      return { ...state, heatmapMode: action.payload };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeLoadingMode: (state, action: PayloadAction<boolean>) => {
      return { ...state, loading: action.payload };
    },
    changeType: (state, action: PayloadAction<Type>) => {
      return { ...state, type: action.payload };
    },
  },
});

export const {
  changeSurveyShowType,
  toggleVisibility,
  makeInvisible,
  changeMarkerMode,
  changeHeatMapMode,
  togglePointwiseShow,
  changeLoadingMode,
  changeType,
} = surveysSlice.actions;

export default surveysSlice.reducer;
